import Box from '@mui/material/Box'
import ListItemAvatar from '@mui/material/ListItemAvatar'
import ListItemText from '@mui/material/ListItemText'
import TextField from '@mui/material/TextField'
import { memo, useState } from 'react'
import { makeStyles } from 'tss-react/mui'

import MenuItemWithCheckbox from '@src/lib/MenuItemWithCheckbox'

import { validAdPreviewTypes } from '../lib/adPreviewTypes'
import useCombinedPremiumAdData from '../lib/useCombinedPremiumAdData'

import PaidAdSocialPreview from './PaidAdSocialPreview'
import LegacySvg from './shared/LegacySvg'

const useStyles = makeStyles()(() => ({
  selectedValue: {
    display: 'flex',
    alignItems: 'center',
  },
}))

const PaidAdPreview = (props) => {
  const { classes } = useStyles()
  const campaignData = useCombinedPremiumAdData(props.campaignId)
  const targetingInfo = campaignData.adSetTemplate.targeting
  const { platforms } = targetingInfo
  const validTypes = validAdPreviewTypes({ platforms, targetingInfo })
  const [selectedPreviewType, setSelectedPreviewType] = useState(
    validTypes[0].type,
  )
  const handlePreviewChange = (evt) => {
    setSelectedPreviewType(evt.target.value)
  }

  return (
    <>
      <TextField
        fullWidth
        onChange={handlePreviewChange}
        select
        SelectProps={{
          classes: {
            root: classes.selectedValue,
          },
        }}
        size="small"
        value={selectedPreviewType}
      >
        {validTypes.map((previewType) => (
          <MenuItemWithCheckbox
            dense
            key={previewType.type}
            value={previewType.type}
          >
            <Box display="flex" alignItems="center">
              <ListItemAvatar>
                <LegacySvg
                  height="36px"
                  symbol={previewType.symbol}
                  width="36px"
                />
              </ListItemAvatar>
              <ListItemText primary={previewType.title} />
            </Box>
          </MenuItemWithCheckbox>
        ))}
      </TextField>
      <PaidAdSocialPreview {...props} type={selectedPreviewType} />
    </>
  )
}

export default memo(PaidAdPreview)
